export default __webpack_public_path__ + "static/media/business.3dec0526.svg";